import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Documents, FetchDocumentsResponse } from "./documents.types";

const initialState: Documents = {
  isLoading: true,
  error: undefined,
};

export const documentsSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    fetch: (state) => {
      return { ...state, isLoading: true };
    },
    fetchSuccess: (state, action: PayloadAction<FetchDocumentsResponse>) => {
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        error: undefined,
      };
    },
    fetchError: (state, { payload: { error } }) => {
      return { ...state, isLoading: false, error };
    },
  },
});
